var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 209,
    viewBox: "0 0 279 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_353_4566)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3229,
    y: 21.3229,
    width: 236.354,
    height: 166.354,
    rx: 14.5521,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2.64583
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5553 134.486H78.0766L67.2193 91.7717C66.7039 89.8068 65.6097 88.0698 64.0002 87.2511C59.9834 85.1937 55.5572 83.5564 50.7286 82.7306V81.0861H74.0527C77.2718 81.0861 79.6861 83.5564 80.0885 86.4253L85.7219 117.236L100.194 81.0861H114.27L92.5553 134.486ZM122.318 134.486H108.644L119.903 81.0861H133.577L122.318 134.486ZM151.268 95.8791C151.671 93.003 154.085 91.3585 156.902 91.3585C161.328 90.9456 166.149 91.7714 170.173 93.8217L172.587 82.3245C168.564 80.68 164.137 79.8542 160.121 79.8542C146.849 79.8542 137.192 87.2509 137.192 97.5164C137.192 105.326 144.032 109.426 148.861 111.897C154.085 114.36 156.097 116.004 155.694 118.468C155.694 122.162 151.671 123.807 147.654 123.807C142.825 123.807 137.997 122.575 133.577 120.518L131.163 132.022C135.992 134.072 141.216 134.898 146.044 134.898C160.925 135.304 170.173 127.914 170.173 116.823C170.173 102.856 151.268 102.037 151.268 95.8791ZM218.029 134.486L207.171 81.0861H195.509C193.095 81.0861 190.681 82.7306 189.876 85.1937L169.771 134.486H183.847L186.657 126.683H203.952L205.562 134.486H218.029ZM197.521 95.4663L201.538 115.592H190.278L197.521 95.4663Z",
    fill: "#172B85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_353_4566",
    x: 0,
    y: 0,
    width: 279,
    height: 209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_353_4566",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.a3bed91609d5612973358b45064062f2.svg";
export { ForwardRef as ReactComponent };